// This is the React component for the Footer
// It's a 3-column layout on desktop that stacks on mobile.

import React, { useLayoutEffect, useRef } from "react";
import "./Footer.css"; // We will create this file next
import { gsap } from "gsap";
import { Link } from 'react-router-dom';
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Import the logo
import footerLogo from "../../../assets/images/FooterLogo.png"; // DRC LOGO FULL

gsap.registerPlugin(ScrollTrigger);

// --- React Component ---
function Footer() {
  const footerRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Simple waterfall reveal for the footer content
      gsap.fromTo(
        footerRef.current, // Animate the whole footer at once
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: footerRef.current,
            start: "top 90%", // Start when 90% from the top
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }, footerRef);

    return () => ctx.revert();
  }, []);

  return (
    <footer className="footer" ref={footerRef}>
      <div className="footer-container">
        
        {/* --- Column 1: Logo --- */}
        <div className="footer-column-logo">
          <img src={footerLogo} alt="Dandelion Run Community Logo" />
        </div>

        {/* --- Column 2: Contact Info --- */}
        <div className="footer-column-info">
          
          <div className="footer-info-item">
            <span className="footer-info-title">ADDRESS</span>
            <div className="footer-info-divider"></div>
            <p>123 Run Way<br />Whitehorse, YT Y1A 1A1</p> {/* Placeholder address */}
          </div>
          
          <div className="footer-info-item">
            <span className="footer-info-title">PHONE</span>
            <div className="footer-info-divider"></div>
            <p>(123) 456-7890</p> {/* Placeholder phone */}
          </div>
          
          <div className="footer-info-item">
            <span className="footer-info-title">EMAIL</span>
            <div className="footer-info-divider"></div>
            <p>Dandelion@runforlife.ca</p>
          </div>

        </div>

        {/* --- Column 3: Button --- */}
        <div className="footer-column-button">
          <Link to="/ContuctUs" className="footer-button">
            CONTACT US
          </Link>
        </div>

      </div>
      
      {/* --- Bottom Copyright Bar --- */}
      <div className="footer-copyright">
        <p>© Dandelion Run Community Copyright 2019</p>
      </div>
    </footer>
  );
}

export default Footer;